export default __webpack_public_path__ + "static/personajePenis-06336774c431e613717d3e4385d0556a.png";